/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, useEffect, useState} from 'react';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {AssetStateOptions} from "../../componentObjects";
const animatedComponents = makeAnimated();


function AssetStateFilter(props) {
    const {selectedState, filterByState} = props;
    const [assetState, setAssetState] = useState({selectedState});

    useEffect(() => {
        setAssetState(selectedState);
        filterByState(selectedState);
    }, [selectedState]);
    
    const onChangeAssetState = (newState) => {
        setAssetState(newState);
        filterByState(newState);
    }
    
    return (
        <span className={"min-width-200 margin-right-15"}>
                <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={AssetStateOptions}
                    onChange={onChangeAssetState}
                    defaultValue={AssetStateOptions[0]}
                    value={assetState}
                />
        </span>
    )
}

export default AssetStateFilter;